import clsx from "clsx";
import { LoaderFunctionArgs, redirect, useLoaderData, useOutletContext } from "react-router";
import routes from "#lib/routes";
import { KemonoLink } from "#components/links";
import { CommunityChannel, fetchCommunityChannelList } from "#lib/api/community-channels";
import { ProfilePageSkeleton } from "#components/pages";
import { CardList } from "#components/cards";
import { Timestamp } from "#components/dates";
import { OutletContext } from "./creators/creator-page";

import * as styles from "./community-channel-index.module.scss";

interface IProps {
  channels: CommunityChannel[];
}

export function CommunityChannelIndex() {
  const { channels } = useLoaderData<IProps>();
  const { creator } = useOutletContext() as OutletContext;
  const title = `${creator.name}'s Community Channels`;

  if (!channels.length) {
    return <>No results found.</>;
  }

  return (
    <ProfilePageSkeleton name="user" title={title} creator={creator}>
      <CardList>
        {channels.map(channel =>
          <article key={channel.channel_id} className={clsx(styles.card, "user-card")}>
            <KemonoLink url={routes.communityChannel(creator.id, channel.channel_id)}>
              <main>
                {channel.name}
              </main>
              {channel.messages_refreshed_at && (
                <footer>
                  Updated: <Timestamp time={channel.messages_refreshed_at} />
                </footer>
              )}
            </KemonoLink>
          </article>
        )}
      </CardList>
    </ProfilePageSkeleton>
  );
}


export async function loader({ params }: LoaderFunctionArgs): Promise<IProps | Response> {
  const creatorId = params.creatorId!;
  const channels = await fetchCommunityChannelList(creatorId);

  if (channels.length == 1) {
    return redirect(routes.communityChannel(creatorId, channels[0].channel_id));
  }

  return {
    channels,
  }
}
